import { FilterWrapper } from "./filterWrapper";

interface TextFilterProps {
  column: any;
  placeholder: string;
}

export const TextFilter: React.FC<TextFilterProps> = ({
  column,
  placeholder,
}) => {
  const filterValue = column.getFilterValue() as string | undefined;

  return (
    <FilterWrapper
      filterValue={filterValue}
      onClear={() => column.setFilterValue(undefined)}
      className="w-3/4"
    >
      <input
        type="text"
        value={filterValue ?? ''}
        onChange={(e) => column.setFilterValue(e.target.value)}
        className="w-full rounded border border-input bg-background px-2 py-1 text-sm font-normal text-foreground placeholder:text-muted-foreground"
        placeholder={placeholder}
      />
    </FilterWrapper>
  );
};
